export default __webpack_public_path__ + "static/media/liberty.6c7c704b.svg";